import React, {Component} from 'react';
import { withTranslation } from "react-i18next";

class SuccessMessage extends Component {
  
  constructor(props) {
    super(props)
    this.state = {
    }
  }
  render() {
    const { t } = this.props;

    return(
      <div>
        <div className="loginIntroTextContainer">
          <h2>{t("thank_you")} </h2>
          <p className="headerdescription">{t("success_reset_password_desc")} </p>
        </div>
        <button type="button" id={"success-done"} className="btn min_outlin_btn active" onClick={()=>this.props.setShowResetPassword(false,this.props.userName)}>
          {t("done_btn")} <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
      </div>
    );
  }
}
export default withTranslation()(SuccessMessage);